import { render, staticRenderFns } from "./OpenServices.vue?vue&type=template&id=40dbd136&scoped=true&"
import script from "./OpenServices.vue?vue&type=script&lang=js&"
export * from "./OpenServices.vue?vue&type=script&lang=js&"
import style0 from "./OpenServices.vue?vue&type=style&index=0&id=40dbd136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dbd136",
  null
  
)

export default component.exports